/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const UpdateAnnouncementDtoMediaTypeEnum = {
    Image: 'image',
    Video: 'video'
};
/**
 * Check if a given object implements the UpdateAnnouncementDto interface.
 */
export function instanceOfUpdateAnnouncementDto(value) {
    return true;
}
export function UpdateAnnouncementDtoFromJSON(json) {
    return UpdateAnnouncementDtoFromJSONTyped(json, false);
}
export function UpdateAnnouncementDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'] == null ? undefined : json['title'],
        'mediaType': json['mediaType'] == null ? undefined : json['mediaType'],
        'mediaUrl': json['mediaUrl'] == null ? undefined : json['mediaUrl'],
        'linkUrl': json['linkUrl'] == null ? undefined : json['linkUrl'],
        'content': json['content'] == null ? undefined : json['content'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'pinned': json['pinned'] == null ? undefined : json['pinned'],
        'highlighted': json['highlighted'] == null ? undefined : json['highlighted'],
    };
}
export function UpdateAnnouncementDtoToJSON(json) {
    return UpdateAnnouncementDtoToJSONTyped(json, false);
}
export function UpdateAnnouncementDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'mediaType': value['mediaType'],
        'mediaUrl': value['mediaUrl'],
        'linkUrl': value['linkUrl'],
        'content': value['content'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'pinned': value['pinned'],
        'highlighted': value['highlighted'],
    };
}
